export default {
  infosKey: 'Clé d\'info',
};
